require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = cf08d1bfc2516f6b7f86
// module chunks = 90